<template>
  <div>
    <the-breadcrumbs></the-breadcrumbs>
    <page-content page-title="QR-Codes">
      <template #actions>
        <region-chooser
          v-if="$store.getters['auth/isSuperAdmin']"
          @region:chosen="handleRegionChange"
        ></region-chooser>
        <el-button type="primary" icon="fal fa-plus" @click="newQrCode">
          Neuer QR-Code
        </el-button>
      </template>

      <data-loader
        ref="dataloader"
        :endpoint="
          `/admin/qr_codes?region_id=${$store.state.auth.chosenRegion}`
        "
      >
        <template #loaded="{ data }">
          <el-table
            style="width: 100%;"
            empty-text="Keine QR-Codes vorhanden"
            stripe
            :data="data.qr_codes"
          >
            <el-table-column prop="label" label="Bezeichnung"></el-table-column>
            <el-table-column prop="target_name" label="Ziel"></el-table-column>
            <el-table-column prop="scanned_count" label="Scans" width="100">
              <template #default="scope">
                {{ scope.row.scanned_count }}
              </template>
            </el-table-column>
            <el-table-column label="Aktionen" width="380">
              <template #default="scope">
                <div class="qr-actions-row">
                  <el-popover
                    placement="left"
                    trigger="hover"
                    width="200"
                    @show="generatePreview(scope.row)"
                  >
                    <div class="qr-preview-container">
                      <img
                        v-if="previewUrls[scope.row.id]"
                        :src="previewUrls[scope.row.id]"
                        width="180"
                        height="180"
                      />
                      <span v-else>Laden...</span>
                    </div>
                    <el-button slot="reference" size="mini" icon="fal fa-eye">
                    </el-button>
                  </el-popover>
                  <el-button
                    icon="fal fa-download"
                    size="mini"
                    @click="downloadQrCode(scope.row)"
                  >
                  </el-button>
                  <el-button
                    icon="fal fa-edit"
                    size="mini"
                    @click="handleEdit(scope.row)"
                  >
                    Bearbeiten
                  </el-button>
                  <delete-button
                    v-slot="slotProps"
                    :on-delete="deleteItem"
                    subject="QR-Code"
                  >
                    <el-button
                      size="mini"
                      icon="fal fa-trash-alt"
                      type="danger"
                      @click="slotProps.handleDelete(scope.row)"
                    >
                      Löschen
                    </el-button>
                  </delete-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </data-loader>
    </page-content>
  </div>
</template>

<script>
import QRCode from "qrcode"
import QrCodesRepository from "@/repositories/qr_codes_repository.js"
import TheBreadcrumbs from "@/components/TheBreadcrumbs"
import PageContent from "@/components/PageContent"
import RegionChooser from "@/components/RegionChooser"
import DataLoader from "@/components/DataLoader"
import DeleteButton from "@/components/DeleteButton.js"

const QR_OPTIONS = {
  errorCorrectionLevel: "H",
  margin: 2,
  color: {
    dark: "#000000",
    light: "#ffffff"
  }
}

export default {
  metaInfo: {
    title: "QR-Codes"
  },
  components: {
    TheBreadcrumbs,
    PageContent,
    RegionChooser,
    DataLoader,
    DeleteButton
  },
  data() {
    return {
      previewUrls: {}
    }
  },
  methods: {
    handleRegionChange() {
      this.$refs.dataloader.loadData()
    },
    handleEdit(qrCode) {
      this.$router.push({ name: "EditQrCodePage", params: { id: qrCode.id } })
    },
    async deleteItem(qrCode) {
      await QrCodesRepository.destroy(qrCode.id)
      this.$refs.dataloader.loadData()
    },
    newQrCode() {
      this.$router.push({ name: "NewQrCodePage" })
    },
    async generatePreview(qrCode) {
      if (this.previewUrls[qrCode.id]) {
        return
      }
      try {
        const dataUrl = await QRCode.toDataURL(qrCode.qr_url, {
          ...QR_OPTIONS,
          width: 180
        })
        this.$set(this.previewUrls, qrCode.id, dataUrl)
      } catch (error) {
        // Silently fail for preview
      }
    },
    async downloadQrCode(qrCode) {
      try {
        const dataUrl = await QRCode.toDataURL(qrCode.qr_url, {
          ...QR_OPTIONS,
          width: 1024
        })

        const link = document.createElement("a")
        link.download = `qr-code-${qrCode.short_code}.png`
        link.href = dataUrl
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        this.$message.error("Fehler beim Erstellen des QR-Codes")
      }
    }
  }
}
</script>

<style scoped>
.qr-preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.qr-actions-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.qr-actions-row >>> .el-button + .el-button {
  margin-left: 0;
}
</style>
